const jsonToSplunkFriendlyString = json =>
  json &&
  Object.keys(json)
    .map(key => {
      const val = typeof json[key] === 'object' ? jsonToSplunkFriendlyString(json[key]) : json[key];

      return `${key}=${val}`;
    })
    .join(' ');

const createErrorMetaData = error => {
  const errorMetaData = {
    statusCode: error.statusCode,
    errorMessage: error.message,
    stack: error.stack
  };

  return jsonToSplunkFriendlyString(errorMetaData);
};

const createContextualData = request => {
  if (request && request.context) {
    const { context, path, query, url } = request;

    return {
      domain: context.site?.domain,
      url,
      path,
      queryParams: query ? JSON.stringify(query) : null,
      traceId: context?.traceInfo['Trace-ID'],
      messageId: context?.traceInfo['Message-ID'],
      deviceId: context.deviceId,
      siteId: context.site?.id,
      brand: context.site?.brand,
      tpid: context.site?.tpid,
      eapid: context.site?.eapid,
      isBot: context.bot,
      userAgent: context.userAgent,
      langId: context.langId,
      locale: context.locale,
      tuid: context.user?.tuid,
      expUserId: context.user?.expUserId,
      userState: context.user?.authState,
      isRegistered: context.user?.isRegistered,
      isSua: context.user?.isSua,
      softAccount: context.user?.softAccount,
      currency: context.currency,
      host: context.host,
      guid: context.guid,
      isMobile: context.deviceInformation?.mobile,
      isTablet: context.deviceInformation?.tablet
    };
  }

  return {};
};

export const logDetailedEvent = (logger, systemEvent, options) => {
  logger.logEvent(
    systemEvent,
    options.message ? options.message : '',
    options.request ? jsonToSplunkFriendlyString(createContextualData(options.request)) : {},
    options.otherMetaData ? jsonToSplunkFriendlyString(options.otherMetaData) : {},
    options.error ? createErrorMetaData(options.error) : {}
  );
};
